import React, { useState } from 'react'
import { Dialog, DialogContent, DialogTitle, TextField, Typography } from '@material-ui/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { useStyles } from './styles'

const AlertAddEvent = ({ open, onClose }) => {
    const [comment, setComment] = useState('')

    const classes = useStyles()

    const handleClose = () => {
        setComment('')
        onClose()
    }
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>¡Espera!</DialogTitle>
            <DialogContent>
                <Typography className={classes.content}>El evento cambia más del xx% del acumulado actual, por lo tanto debe añadir un comentario para justificar su cambio.</Typography>
                <TextField
                    label='Comentario'
                    variant='outlined'
                    className={classes.textArea}
                    fullWidth
                    multiline
                    minRows={7}
                    onChange={(e) => setComment(e.target.value)}
                />
                <div className={classes.btnsContainer}>
                    <Button className={classes.cancelBtn} onClick={handleClose}>Cancelar</Button>
                    <Button color='tumblr' className={classes.acceptBtn} >Enviar</Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export { AlertAddEvent }